<template>
  <div class="wrapper">

    <div class="header_wrapper">
      <v-toolbar
        color="primary"
        dark
      >
        <v-btn
          @click="routerBack"
          style="position: absolute"
          icon
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title class="text-center ml-0">{{ t('childAdd.title') }}</v-toolbar-title>
      </v-toolbar>
    </div>

    <v-container fluid>
      <v-form ref="search_child_form">
        <div>
          <p class="body-2 blue-grey--text">{{ t('childAdd.childIdLabel') }}</p>
          <v-text-field
            v-model="childCode"
            :rules="[rules.required]"
            outlined
            dense
          ></v-text-field>
        </div>

        <div>
          <p class="body-2 blue-grey--text">{{ t('childAdd.password') }}</p>
          <v-text-field
            v-model="password"
            :rules="[rules.required]"
            outlined
            dense
            type="password"
          ></v-text-field>
        </div>

        <div class="d-flex justify-center my-5">
          <v-btn
            @click="searchChild"
            :loading="btnLoading"
            color="primary"
            block
          >
            {{ t('childAdd.submit') }}
          </v-btn>
        </div>

      </v-form>
    </v-container>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import rules from '@/service/ValidRules';
import { Toast } from '@/service/SweetAlert';

import { familyModule } from '@/store/entityModules/family';
import { t } from '@/i18n';

// model
import type { VForm } from 'vuetify/components';

export default defineComponent({

  computed: {
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).search_child_form;
    },
    family() {
      return familyModule.family;
    },
  },

  data: () => ({
    childCode: '',
    password: '',
    btnLoading: false,
  }),

  methods: {
    t,
    routerBack() {
      this.$router.replace('/setting/family');
    },
    async searchChild() {
      const { valid } = await this.form.validate();
      if (valid && this.family) {
        this.btnLoading = true;
        try {
          await familyModule.fetchChildrenSearch({
            childCode: this.childCode,
            password: this.password,
          });
          await familyModule.postFamilyChildRequest({
            familyId: String(this.family.familyId),
            childCode: this.childCode,
            password: this.password,
          });
          Toast.fire({
            icon: 'success',
            title: this.t('childAdd.successMessage'),
          });
          this.routerBack();
          this.btnLoading = false;
        } catch (error) {
          this.btnLoading = false;
        }
      }
    },
  },

});
</script>
<style lang="scss" scoped>
/* ===== レイアウト ===== */
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
// リストはヘッダー分だけ下げる
.v-list {
  margin-top: calc(55px + env(safe-area-inset-top));
}
</style>
